module.exports = __webpack_public_path__ + "HelveticaNeueLTStdBd.32bab3aec416a2eff618.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/HelveticaNeueLTStdBd.ttf
// module id = ../../../../../src/assets/fonts/HelveticaNeueLTStdBd.ttf
// module chunks = styles